import React, {
  Component,
  PropTypes
} from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {} from '../actions/';
import IdeaPage from '../components/MakeIdeas/IdeaPage';
import {INITIATIVE_TYPE, CIP_TYPE} from '../constants';
import {fetchCipGroupsAction, postCipIdeaAction, fetchInitiativeTypesAction , addInitiativeAction, fetchManagerAction} from '../actions';
class IdeaContainer extends Component {
  render() {
    const ideaType = (this.props.params && this.props.params.ideaType) ? this.props.params.ideaType : INITIATIVE_TYPE;
    const { actions } = this.props;
    const { cipGroups } = this.props;
    const {locale} = this.props;

    const { initiativeTypes } = this.props;
    initiativeTypes.Types.forEach((itype) => {
      if(locale == 'en'){
          itype.label = itype.TitleEN ? itype.TitleEN : itype.Title; 
      }
      else if(locale == 'sv'){
        itype.label = itype.TitleSV ? itype.TitleSV : itype.Title; 
      }
      else{
        itype.label = itype.Title;
      }
    });

    this.state = {
      ideaType : ideaType
    };
    return <IdeaPage initiativeTypes={initiativeTypes} actions={actions} ideaType={ideaType} cipGroups={cipGroups} router={this.props.router} locale={locale}/>;
  }
}

IdeaContainer.propTypes = {
  actions: PropTypes.shape({})
};

function mapStateToProps(state) {
  const props = {cipGroups : state.cipGroups, initiativeTypes : state.initiativeTypes , locale : state.locale};
  return props;
}

function mapDispatchToProps(dispatch) {
  const actions = {fetchCipGroupsAction, postCipIdeaAction, fetchInitiativeTypesAction, addInitiativeAction, fetchManagerAction};
  const actionMap = { actions: bindActionCreators(actions, dispatch) };
  return actionMap;
}

export default connect(mapStateToProps, mapDispatchToProps)(IdeaContainer);



// WEBPACK FOOTER //
// ./containers/IdeaContainer.js